import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import NavBar from './NavBar';
import { useTheme } from '../context/ThemeContext';

export default function AppLayout() {
  const { theme } = useTheme();
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

  return (
    <div className={`app-shell ${theme === 'dark' ? 'theme-dark' : ''} ${isSidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
      <Sidebar
        isCollapsed={isSidebarCollapsed}
        isMobileOpen={isMobileSidebarOpen}
        onCloseMobileMenu={() => setIsMobileSidebarOpen(false)}
      />
      <main className="app-main">
        <NavBar
          onToggleSidebar={() => setIsSidebarCollapsed((prev) => !prev)}
          isSidebarCollapsed={isSidebarCollapsed}
          onOpenMobileMenu={() => setIsMobileSidebarOpen(true)}
        />
        <div className="app-content">
          <Outlet />
        </div>
      </main>
    </div>
  );
}